import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, SimpleChanges,Output,EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';
import { DialogData } from '../../dialogs/options-dialog/options-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MyBoolean, OrderDetails, OrderDetailsNew, ToothData } from '../../../models/order.models';
import { MatSliderModule } from '@angular/material/slider';
import { DataService } from '../../../Services/data.service';
import { MagnifierComponent } from '../../magnifier/magnifier.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-abutment-marginal-height',
  standalone: true,
  imports: [MatSliderModule, MatDialogModule, CommonModule, MatListModule, MatButtonModule, MatRadioModule, FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MagnifierComponent,MatCheckboxModule],
  templateUrl: './abutment-marginal-height.component.html',
  styleUrls: ['./abutment-marginal-height.component.css', '../../../../style-custom.css'],
})
export class AbutmentMarginalHeightComponent {

  @Input() orderDetailsNew!: OrderDetailsNew;
  @Input() showSlider: MyBoolean | undefined;
  @Input() readonly: boolean = false;
  @Input() anterior!: boolean;
  @Input() teeth!: number[];
  @Output() abutmentStep4Change = new EventEmitter<string>();
 @Input() abutmentSelectedTeeth: number[] = [];
  
  q1DefaultValue: string = '1/3 of the surface';
  q2DefaultValue: string = '0.03 mm light occlusion (standard)';
  // q3DefaultValue: string = 'Buccal light equator, approx. 1.6 mm distance cervical (Standard)';

  constructor(public dataService: DataService) { }

  ngOnInit() {
    if(this.orderDetailsNew){
      this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] = this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] ? this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] : this.q1DefaultValue;
      this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] = this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] ? this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] : this.q2DefaultValue;
    }
  }

  rearrangedTeethOrderIgnoringBridgedTeeth(teeth: number[]): string {
    var bridgedTeethNotStartEnd = this.orderDetailsNew.bridges.map((bridge) => {
      return bridge.bridgedTeeth.filter((tooth) => tooth !== bridge.start && tooth !== bridge.end);
    }).flat();

    return this.dataService.rearrangedTeethOrder(teeth.filter((tooth) => tooth != 18 && tooth != 28 && tooth != 48 && tooth != 38 && !bridgedTeethNotStartEnd.includes(tooth)));
  }
 
  close(): void {
    if(this.showSlider){
      this.showSlider.value = false;
    }
  }

  get isAbutmenthighlySelected(): boolean {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return false;
  return this.abutmentSelectedTeeth.some(selectedTeethId => {
    const tooth = this.orderDetailsNew.toothData.find(t => t.teeth === selectedTeethId);
    return tooth?.['abutmentStep1'] === 'Highly placed implant';
  });
}
  
  onAabutmentStep4Selection(AbutmentStep4Option: string) {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return;

  this.abutmentSelectedTeeth.forEach(selectedTeethId => {
    const tooth = this.orderDetailsNew.toothData.find(t => t.teeth === selectedTeethId);
    if (tooth) {
      tooth['abutmentStep4'] = AbutmentStep4Option;
    }
  });

  this.abutmentStep4Change.emit(AbutmentStep4Option);
}
 shouldBeCheckedForTooth(step: string, value: string): boolean {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return false;

  return this.abutmentSelectedTeeth.some(selectedToothId => {
    const toothData = this.orderDetailsNew.toothData.find(t => t.teeth === selectedToothId);
    return toothData?.[step] === value;
  });
}

  getParamValue(key: string): number | null {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return null;

  const firstToothId = this.abutmentSelectedTeeth[0];
  const selectedTooth = this.orderDetailsNew.toothData.find(t => t.teeth === firstToothId);

  const defaultValue = this.isAbutmenthighlySelected ? 0 : -0.5;

  const val = selectedTooth?.[key];
  if (val === undefined || val === null) return defaultValue;

  if (typeof val === 'number') return val;

  const n = Number(val);
  return Number.isNaN(n) ? null : n;
}

  setParamValue(key: string, value: any) {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return;

  // Update all selected teeth
  this.abutmentSelectedTeeth.forEach(toothId => {
    const tooth = this.orderDetailsNew.toothData.find(x => x.teeth === toothId);
    if (tooth) {
      tooth[key] = value;
    }
  });

  // Optionally: emit event / save to backend
}

getAllParamValue(key:string):number | null{
    return this.getParamValue('adjustAll')
  }

  setAllParamValue(key: string, value: any) {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return;

  const toothParameters = ['mesial', 'distal', 'vestibular', 'oral', 'adjustAll'];

  this.abutmentSelectedTeeth.forEach(toothId => {
    const tooth = this.orderDetailsNew.toothData.find(t => t.teeth === toothId);
    if (tooth) {
      toothParameters.forEach(param => {
        tooth[param] = value;
      });

      tooth[key] = value;
    }
  });
}
}
